







import { Component, Prop, Vue } from 'vue-property-decorator';
import LocationPanelNav from '@/components/location/location-panel/LocationPanelNav.vue';
import LocationPanelMobileNav from '@/components/location/location-panel/location-panel-mobile/LocationPanelMobileNav.vue';
import LocationModel from '@/location/Location';
import Category from '@/category/Category';

@Component({
    components: { LocationPanelMobileNav, LocationPanelNav },
})
export default class LocationPanel extends Vue {
    @Prop({ type: LocationModel, required: true })
    location!: LocationModel;

    private get categories(): Array<Category> | undefined {
        return Category.query()
            .withAllRecursive()
            .orderBy('weight', 'asc')
            .all();
    }
}
